<template>
    <div class="case-page">
        <!-- ===== 顶部 Banner（轮播） ===== -->
        <section class="hero" :style="heroBgStyle">
            <button class="hero-arrow left" type="button" @click="prevHero" aria-label="prev">‹</button>
            <button class="hero-arrow right" type="button" @click="nextHero" aria-label="next">›</button>

            <div class="hero-inner">
                <div class="hero-top">
                    <img v-if="heroSlides[heroIndex].brandLogo" class="hero-brand"
                        :src="heroSlides[heroIndex].brandLogo" alt="" />
                    <div class="hero-stock" v-if="heroSlides[heroIndex].stockCode">{{ heroSlides[heroIndex].stockCode }}
                    </div>
                </div>

                <div class="hero-center">
                    <div class="hero-big">{{ heroSlides[heroIndex].line1 }}</div>
                    <div class="hero-big">{{ heroSlides[heroIndex].line2 }}</div>
                    <div class="hero-sub">{{ heroSlides[heroIndex].sub }}</div>
                </div>

                <div class="hero-bars" aria-hidden="true">
                    <span v-for="(s, i) in heroSlides" :key="i" class="bar" :class="{ active: i === heroIndex }"></span>
                </div>
            </div>
        </section>

        <!-- ===== 经典案例 ===== -->
        <section class="classic">
            <h2 class="sec-title">经典案例</h2>

            <div class="classic-card">
                <div class="classic-left">
                    <img class="phone-img" :src="classicSlides[classicIndex].phoneImg" alt="" />
                </div>

                <div class="classic-right">
                    <img class="case-logo" :src="classicSlides[classicIndex].logo" alt="" />
                    <h3 class="case-title">{{ classicSlides[classicIndex].title }}</h3>
                    <p class="case-desc">{{ classicSlides[classicIndex].desc }}</p>

                    <div class="ps">
                        <div class="ps-item">
                            <div class="ps-hd">
                                <span class="ps-ico green" aria-hidden="true"></span>
                                <span class="ps-ttl">全品类制造加工</span>
                            </div>
                            <p class="ps-txt">{{ classicSlides[classicIndex].pain }}</p>
                        </div>

                        <div class="ps-item">
                            <div class="ps-hd">
                                <span class="ps-ico blue" aria-hidden="true"></span>
                                <span class="ps-ttl">专业制造加工</span>
                            </div>
                            <p class="ps-txt">{{ classicSlides[classicIndex].solution }}</p>
                        </div>
                    </div>

                    <!-- <div class="btns">
                        <button class="btn ghost" type="button" @click="onMore">了解更多</button>
                        <button class="btn primary" type="button" @click="onGetMore">获取更多解决方案</button>
                    </div> -->

                    <div class="dots" aria-hidden="true">
                        <span v-for="(s, i) in classicSlides" :key="i" class="dot"
                            :class="{ active: i === classicIndex }" @click="classicIndex = i"></span>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";

// 进页面强制回到顶部（避免“从首页底部点进来”落在底部）
onMounted(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
});

/** 顶部 banner 轮播数据（你换成真实图） */
const heroSlides = ref([
    {
        bg: require("../static/1.webp"),
        brandLogo: "", // 可填 logo
        stockCode: "技明电器",
        line1: "家电灯具智造，塑胶五金精工，全球贸易通途！",
        line2: "全品类制造加工，自营进出口无忧",
        sub: "制造加工强实力，进出口业务广覆盖",
    },
    {
        bg: require("../static/2.webp"),
        brandLogo: "",
        stockCode: "技明电器",
        line1: "欢迎新老客户咨询，携手共赢",
        line2: "全品类制造加工，进出口一条龙服务",
        sub: "工厂直供，全球直达！",
    },
]);

const heroIndex = ref(0);
const heroBgStyle = computed(() => ({
    backgroundImage: `linear-gradient(180deg, rgba(0,0,0,.28), rgba(0,0,0,.28)), url(${heroSlides.value[heroIndex.value].bg})`,
}));

function prevHero() {
    heroIndex.value = (heroIndex.value - 1 + heroSlides.value.length) % heroSlides.value.length;
}
function nextHero() {
    heroIndex.value = (heroIndex.value + 1) % heroSlides.value.length;
}

/** 经典案例（你换成真实图 + 文案） */
const classicSlides = ref([
    {
        phoneImg: require("../static/4.webp"),
        logo: require("../static/logo.webp"),
        title: "集家电、照明、塑胶、五金四大品类制造加工于一体",
        desc: "拥有先进的生产设备与专业的技术团队",
        pain: "自营 + 代理双模式进出口服务，为您打通国内外市场，实现从生产到交付的全链条无忧合作。",
        solution: "具备自营和代理各类货物及技术进出口的完整资质，助力产品远销全球，搭建国际合作的坚实桥梁",
    },
]);

const classicIndex = ref(0);

// function onMore() {
//     // TODO：跳转到某个详情页（你按项目改）
//     // router.push({ name: 'caseDetail', query: { id: classicSlides.value[classicIndex.value].id } })
//     alert("这里接入“了解更多”的跳转");
// }
// function onGetMore() {
//     alert("这里接入“获取更多解决方案”的跳转");
// }

// 说明：案例数据后续可替换为公司真实客户与图片
</script>

<style scoped>
.case-page {
    background: #fff;
}

/* ===== 顶部 Banner ===== */
.hero {
    position: relative;
    height: 420px;
    background-size: cover;
    background-position: center;
    overflow: hidden;
}

.hero-inner {
    height: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 18px 18px 16px;
    display: flex;
    flex-direction: column;
}

.hero-top {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    color: rgba(255, 255, 255, .95);
}

.hero-brand {
    height: 28px;
    object-fit: contain;
}

.hero-stock {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: .5px;
}

.hero-center {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #fff;
}

.hero-big {
    font-size: 30px;
    font-weight: 700;
    line-height: 1.4;
    text-shadow: 0 10px 30px rgba(0, 0, 0, .35);
}

.hero-sub {
    margin-top: 18px;
    font-size: 14px;
    opacity: .9;
}

.hero-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 44px;
    height: 44px;
    border: none;
    border-radius: 999px;
    background: rgba(255, 255, 255, .16);
    color: #fff;
    font-size: 26px;
    cursor: pointer;
    z-index: 2;
}

.hero-arrow:hover {
    background: rgba(255, 255, 255, .22);
}

.hero-arrow.left {
    left: 18px;
}

.hero-arrow.right {
    right: 18px;
}

.hero-bars {
    display: flex;
    gap: 10px;
    justify-content: center;
    padding-bottom: 10px;
}

.bar {
    width: 34px;
    height: 3px;
    background: rgba(255, 255, 255, .45);
    border-radius: 99px;
}

.bar.active {
    width: 46px;
    background: rgba(255, 255, 255, .92);
}

/* ===== 标题通用 ===== */
.sec-title {
    margin: 0;
    padding: 58px 0 26px;
    text-align: center;
    font-size: 28px;
    font-weight: 700;
    color: #333;
}

/* ===== 经典案例 ===== */
.classic {
    padding-bottom: 24px;
}

.classic-card {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 18px 12px;
    background: #fff;
    border: 1px solid #eef1f5;
    border-radius: 20px;
    box-shadow: 0 18px 44px rgba(16, 42, 67, .08);
    display: grid;
    grid-template-columns: 1fr 1.25fr;
    gap: 28px;
    align-items: center;
    min-height: 360px;
    overflow: hidden;
}

.classic-left {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.phone-img {
    width: min(420px, 100%);
    height: auto;
    object-fit: contain;
    filter: drop-shadow(0 18px 28px rgba(0, 0, 0, .12));
}

.classic-right {
    padding: 24px 26px 18px 0;
}

.case-logo {
    height: 44px;
    object-fit: contain;
}

.case-title {
    margin: 14px 0 0;
    font-size: 18px;
    font-weight: 700;
    color: #333;
}

.case-desc {
    margin: 10px 0 0;
    color: #777;
    line-height: 1.9;
    font-size: 13px;
    max-width: 520px;
}

.ps {
    margin-top: 18px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
}

.ps-item {
    border: 1px solid #eee;
    background: #fff;
    padding: 14px 14px 12px;
}

.ps-hd {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 700;
    color: #333;
}

.ps-ico {
    width: 18px;
    height: 18px;
    border-radius: 4px;
}

.ps-ico.green {
    background: #7cc35c;
}

.ps-ico.blue {
    background: #1f6bd6;
}

.ps-txt {
    margin: 10px 0 0;
    color: #666;
    font-size: 12px;
    line-height: 1.8;
}

.btns {
    margin-top: 18px;
    display: flex;
    gap: 12px;
}

.btn {
    height: 34px;
    padding: 0 18px;
    border-radius: 2px;
    cursor: pointer;
    font-size: 13px;
}

.btn.ghost {
    border: 1px solid #7aa7d9;
    background: #fff;
    color: #2a6fb8;
}

.btn.primary {
    border: 1px solid #0a4f97;
    background: #0a4f97;
    color: #fff;
}

.btn:hover {
    filter: brightness(.98);
}

.dots {
    margin-top: 16px;
    display: flex;
    gap: 10px;
    justify-content: center;
}

.dot {
    width: 8px;
    height: 8px;
    border-radius: 99px;
    background: #d6d6d6;
    cursor: pointer;
}

.dot.active {
    background: #1f6bd6;
}

/* ===== 合作案例 ===== */
.coop {
    padding-bottom: 68px;
}

.coop-grid {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 18px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 26px 26px;
}

.coop-card {
    display: block;
    text-decoration: none;
    color: inherit;
}

.coop-logoBox {
    height: 190px;
    background: #f6f6f6;
    display: flex;
    align-items: center;
    justify-content: center;
}

.coop-logo {
    max-width: 70%;
    max-height: 70%;
    object-fit: contain;
}

.coop-title {
    margin-top: 10px;
    color: #666;
    font-size: 13px;
    line-height: 1.6;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* hover */
.coop-card:hover .coop-logoBox {
    background: #f0f3f8;
}

/* ===== 响应式 ===== */
@media (max-width: 1100px) {
    .coop-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    .classic-card {
        grid-template-columns: 1fr;
    }

    .classic-right {
        padding: 10px 18px 18px;
    }
}

@media (max-width: 760px) {
    .hero {
        height: 340px;
    }

    .hero-big {
        font-size: 22px;
    }

    .ps {
        grid-template-columns: 1fr;
    }

    .coop-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 420px) {
    .coop-grid {
        grid-template-columns: 1fr;
    }
}
</style>
